// extracted by mini-css-extract-plugin
export var actionButton = "_db-0";
export var attachmentLine = "_db-1";
export var fileInput = "_db-2";
export var fileUploadWrapper = "_db-4";
export var footer = "_db-3";
export var modalContent = "_db-5";
export var paperclip = "_db-6";
export var quillEditor = "_db-7";